/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';
import variableProductHasEmptyAttribute from '../helpers/variable-product-has-empty-attribute';
import selectedVariation from '../helpers/selected-variation';
import getWcFragmentsRefreshed from '../helpers/get-wc-fragments-refreshed';
import Toastify from '../helpers/toastify';

export default function() {

    const toastifyMessage = button => {

        let toastifyText = button.attr('data-add_to_cart_msg');
        toastifyText = toastifyText ? toastifyText : 'Das Produkt wurde in den Warenkorb gelegt.';
    
        Toastify({
            text: toastifyText,
            destination: wc_add_to_cart_params.cart_url ? wc_add_to_cart_params.cart_url : undefined,
            duration: 3000,
            close: false,
            gravity: "bottom", // `top` or `bottom`
            position: "right", // `left`, `center` or `right`
            stopOnFocus: true, // Prevents dismissing of toast on hover
            progressBar: true,
            backgroundColor: '#F68500',
            progressBarStyle: {background: '#999999', barBackground: '#313131', height: '5px'},
        }).showToast();
    
    }

    // On load

    $('.footer-variations').each(function(idx, variation){

        let addToCartButton = jQuery(this).parent().find('.add_to_cart_button_footer');
        
        if( variableProductHasEmptyAttribute( jQuery(this).find('select') ) ) {
            addToCartButton.attr('disabled', 'disabled');
        } else {
            
            let variation = selectedVariation( jQuery(this).data('product_variations'), jQuery(this).find('select') );
            if( variation ) {
                addToCartButton.attr({
                    'data-variation_id': variation.variation_id,
                    'data-quantity': variation.min_qty
                });
                jQuery(this).parents('.add-to-cart-variable-overlay').find('.variation-price').html( variation.price_html );
            }
        }

    });

    $('.product-footer-data a.add-to-cart.simple').on('click', function(evt){
        evt.preventDefault();

        let addToCartButton = jQuery(this);
        $.post(
            '/?wc-ajax=add_to_cart',
            {
                product_sku: addToCartButton.data('product_sku'),
                product_id: addToCartButton.data('product_id'),
                quantity: 1
            },
            function (response) {

                if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
                    window.location = wc_add_to_cart_params.cart_url;
                    return;
                }
                
                toastifyMessage(addToCartButton);
                getWcFragmentsRefreshed();
                
            }
        );
    });

    $('.product-footer-data a.add-to-cart.variable').on('click', function(evt){
        evt.preventDefault();
        jQuery(this).parents('.product-footer-data').find('.add-to-cart-variable-overlay').slideDown().css('display', 'flex');
    });

    $('.add-to-cart-variable-overlay-close').on('click', function(evt){
        evt.preventDefault();
        jQuery(this).parents('.add-to-cart-variable-overlay').slideUp();
    })

    // On footer variation dropdown change

    $('.footer-variations select').on('change', function (evt) {

        let container       = jQuery(this).parents('.footer-variations-form');
        let attributes      = jQuery(this).parents('.footer-variations').data('product_variations');
        let variation       = selectedVariation( attributes, jQuery(this).parents('.footer-variations').find('select') );
        let addToCartButton = container.find('.add_to_cart_button_footer');

        if( variation ) {

            addToCartButton.removeAttr('disabled');
            addToCartButton.attr({
                'data-variation_id': variation.variation_id,
                'data-quantity': variation.min_qty
            });
            container.find('.variation-price').html( variation.price_html );

        } else {

            addToCartButton.attr('disabled', 'disabled');
            addToCartButton.attr({
                'data-variation_id': '',
                'data-quantity': ''
            });
            container.find('.variation-price').html('');
        }

    });

    $('.add_to_cart_button_footer').on('click', function(evt){
        evt.preventDefault();
        
        let container          = jQuery(this).parents('.footer-variations-form');
        let addToCartButton    = jQuery(this);
        let variationDropdowns = container.find('select');
        let data = {
            action: 'add_to_cart_variable_product',
            quantity: addToCartButton.attr('data-quantity'),
            product_id: addToCartButton.attr('data-product_id'),
            variation_id: addToCartButton.attr('data-variation_id')
        };

        addToCartButton.addClass('loading');

        variationDropdowns.each(function(idx, variation){
            data[ jQuery(this).attr('name') ] = jQuery(this).val();
        });
        
        $.post(
            wc_add_to_cart_params.ajax_url,
            data,
            function (response) {

                // Redirect to cart option
                if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
                    window.location = wc_add_to_cart_params.cart_url;
                    return;
                }

                toastifyMessage(addToCartButton);

                addToCartButton.removeClass('loading');

                getWcFragmentsRefreshed();

            }
        );

    });
    
}